"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const models_1 = require("../modules/models");
const selectors_1 = require("../modules/selectors");
const form_1 = require("../modules/form");
const rulesets_1 = require("../modules/rulesets");
const reporter_1 = __importDefault(require("../reporter"));
class DynamicFusion extends react_1.Component {
    handleChange = changes => {
        const { inputUpdate, inputs = [], formId, formIndex, dispatchRulesets, } = this.props;
        (0, react_redux_1.batch)(() => {
            inputs
                .filter(({ fusionName }) => typeof changes[fusionName] !== 'undefined')
                .map(({ fusionName, ...inputProps }) => inputUpdate({
                ...inputProps,
                formId,
                formIndex,
                value: changes[fusionName],
            }));
            dispatchRulesets(inputs.reduce((acc, { rulesets = [] }) => [...acc, ...rulesets], []));
        });
    };
    handleSubmission = (name, passData) => {
        const { inputs, submitPayloads, triggerSubmission } = this.props;
        const submit = inputs.find(({ fusionName }) => fusionName === name);
        const submitPayload = submitPayloads[name];
        if (submit && submit.submission && submitPayload) {
            triggerSubmission({ submission: submit.submission, submitPayload }, passData);
        }
        else {
            reporter_1.default.warn('No submission made', {
                name,
                submit,
                submitPayload,
            });
        }
    };
    render() {
        const { component, ...remProps } = this.props;
        const props = {
            ...remProps,
            onChange: this.handleChange,
            onSubmit: this.handleSubmission,
        };
        return react_1.default.createElement(component, props);
    }
}
const mapState = (state, { inputs = [], ...groupProps }) => ({
    submitPayloads: inputs
        .filter(({ type, fusionName }) => type === 'submit' && fusionName)
        .reduce((acc, { fusionName, ...props }) => ({
        ...acc,
        [fusionName]: (0, selectors_1.submissionSelector)(state, { ...groupProps, ...props }),
    }), {}),
});
const mapDispatch = (dispatch, { dispatchers, formId, formIndex, repeatIndex, enableRulesets }) => ({
    inputUpdate: payload => dispatch((0, models_1.updateValueAndRun)(payload)),
    triggerSubmission: ({ submission, submitPayload }, passData) => {
        dispatch((0, form_1.submitClick)({
            submission,
            submitPayload,
            dispatchers,
            formId,
            repeatIndex,
        }, passData));
    },
    dispatchRulesets: rulesets => {
        if (enableRulesets) {
            dispatch((0, rulesets_1.runRulesets)({ formId, formIndex, rulesets }));
        }
    },
});
exports.default = (0, react_redux_1.connect)(mapState, mapDispatch)(DynamicFusion);
//# sourceMappingURL=DynamicFusion.js.map